import {

    GET_HOME_DATA_REQUEST, GET_HOME_DATA_SUCCESS, GET_HOME_DATA_FAILURE,
    GET_POST_CATEGRY_REQUEST, GET_POST_CATEGRY_SUCCESS, GET_POST_CATEGRY_FAILURE,
    GET_INTREST_REQUEST, GET_INTREST_SUCCESS, GET_INTREST_FAILURE,
    GET_TEG_LIST_REQUEST, GET_TEG_LIST_SUCCESS, GET_TEG_LIST_FAILURE, TOGGLE_THEME,


} from '../actions/action-types';


const initialState = {
    lang: "en", isRTL: false,
    homeSliderList: [],
    homeCategryList: [],
    intrest: [],
    tegListdata: [],
    theme: 'dark'
}

export const common = (state = initialState, { type, payload }) => {
    switch (type) {

        case TOGGLE_THEME:
            return {
                ...state,
                theme: state.theme === 'dark' ? 'light' : 'dark' // Toggle between 'light' and 'dark'
            };

        // GET_HOME_DATA
        case GET_HOME_DATA_REQUEST:
            return {
                ...state,
            }
        case GET_HOME_DATA_SUCCESS:
            return {
                ...state, homeSliderList: payload?.data || [],
            }
        case GET_HOME_DATA_FAILURE:
            return {
                ...state, homeSliderList: []
            }

        // GET_POST_LIST
        case GET_POST_CATEGRY_REQUEST:
            return {
                ...state,
            }
        case GET_POST_CATEGRY_SUCCESS:
            return {
                ...state, homeCategryList: payload?.data || [],
            }
        case GET_POST_CATEGRY_FAILURE:
            return {
                ...state, homeCategryList: []
            }

        // GET_INTERST
        case GET_INTREST_REQUEST:
            return {
                ...state,
            }
        case GET_INTREST_SUCCESS:
            return {
                ...state, intrest: payload?.data || [],
            }
        case GET_INTREST_FAILURE:
            return {
                ...state, intrest: []
            }

        // GET_INTERST
        case GET_TEG_LIST_REQUEST:
            return {
                ...state,
            }
        case GET_TEG_LIST_SUCCESS:
            return {
                ...state, tegListdata: payload?.data || [],
            }
        case GET_TEG_LIST_FAILURE:
            return {
                ...state,
            }



        default:
            return state
    }
}